import { toast } from '@main/ui';
import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit';

import { BackofficeAppDispatch, BackofficeRootState } from '../../store';
import { nhost } from '../../utils/nhost-client';
import { previewFile } from './slice';

export const fileListenerMiddleware = createListenerMiddleware();

const startListening = fileListenerMiddleware.startListening as TypedStartListening<
  BackofficeRootState,
  BackofficeAppDispatch
>;

startListening({
  actionCreator: previewFile,
  effect: async ({ payload }, { unsubscribe, subscribe }) => {
    unsubscribe();

    const presignedUrlResponse = await nhost.storage.getPresignedUrl({
      fileId: payload.fileId,
    });

    if (!presignedUrlResponse.presignedUrl) {
      toast({
        title: 'Not valid file_id',
        status: 'error',
      });
      return;
    }

    window.open(presignedUrlResponse.presignedUrl?.url, '_blank');

    subscribe();
  },
});
